import {
    Button,
    Col,
    Collapse,
    Form,
    Input,
    message,
    Pagination,
    Row,
    Select,
    Space,
    Switch,
    Table,
    Tag,
    Tooltip
} from "antd";
import {ExclamationCircleOutlined, EyeOutlined, TeamOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import adminService from "../../../service/adminService";
import {CustomerFilterDto} from "../../../dto/admin/CustomerFilterDto";
import {COMMON_DROPDOWN, IDENTIFICATION_SOURCE, PARAMETER_LIST} from "../../../util/Constants";
import CommonFunction from "../../../util/CommonFunction";
import {
    MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR,
    MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {DropdownListDto} from "../../../dto/DropdownListDto";
import {InputDropdownParameterDto} from "../../../dto/InputDropdownParameterDto";
import customerService from "../../../service/customerService";
import modal from "antd/es/modal";
import {UserMstDto} from "../../../dto/UserMstDto";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";

const {Panel} = Collapse;

const CustomerDetailsTablePage = () => {

    const history = useHistory();
    const [tableData, setTableData] = useState<any[]>();
    const [loading, setLoading] = useState<boolean>(false);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
        total: 10,
    });
    const [form] = Form.useForm();
    const [filter, setFilter] = useState<CustomerFilterDto>({
        cin: null,
        contactNo: null,
        customerName: null,
        email: null,
        rmId: null,
        identificationSource: null,
        identificationValue: null,
        page: 1,
        size: 10,
        sort: ['createdDate', 'desc']
    });
    const [identificationSourceTypeList, setIdentificationSourceTypeList] = useState<DropdownListDto[]>([]);
    const [switchStates, setSwitchStates] = useState<{ [key: string]: boolean }>({});
    const columns = [
        {
            title: 'CIN',
            dataIndex: 'cin',
            key: 'cin',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Customer Name',
            dataIndex: 'customerName',
            key: 'customerName',
            render: (text: any, rec: any) => {
                return <pre style={{display: 'inline'}}>{CommonFunction.validateText(text)}</pre>
            }
        },
        {
            title: 'Identification Source',
            dataIndex: 'identificationSource',
            key: 'identificationSource',
            align: 'center',
            render: (text: any, rec: any) => {
                return (
                    <Tag
                        className={getClassName(text)}
                        color={getColor(text)} key={text}>
                        {null != text ? text.toUpperCase() : 'N/A'}
                    </Tag>
                )
            }
        },
        {
            title: 'Identification Number',
            dataIndex: 'identificationValue',
            key: 'identificationValue',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'RM Name',
            dataIndex: 'rmName',
            key: 'rmName',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Contact Number',
            dataIndex: 'contactNo',
            key: 'contactNo',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text: any, rec: any) => {
                return <span>{CommonFunction.validateText(text)}</span>
            }
        },
        {
            title: 'Username',
            dataIndex: 'username',
            key: 'username',
            render: (text: any, rec: any) => {
                return (<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                    <span>{CommonFunction.validateText(text)}</span>
                    {null == text || undefined == text || "" == text ?
                        <Button
                            type="text"
                            icon={<FontAwesomeIcon icon={faEnvelope}/>}
                            disabled={true}
                        />
                        :
                        <Tooltip placement="topRight" title="Send Username">
                            <Button
                                type="text"
                                icon={<FontAwesomeIcon icon={faEnvelope}/>}
                                onClick={() => handleSendUsernameAsEmail(text)}
                            />
                        </Tooltip>
                    }
                </div>)
            }
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            align: "center",
            render: (text: any, rec: any) => {
                const isChecked = switchStates[rec.username] !== undefined
                    ? switchStates[rec.username]
                    : text === 'ACTIVE';

                return (
                    <Switch
                        checkedChildren="Enable"
                        unCheckedChildren="Disable"
                        checked={isChecked}
                        disabled={null == rec.username}
                        onChange={(value: boolean) => handleSwitchChange(value, rec)}
                        className={'customer-status-change-switch'}
                    />
                );
            }
        },
        {
            title: 'Action',
            key: 'action',
            align: "center",
            fixed: 'right' as const,
            render: (rec: any) => (
                <Space size="middle">
                    <Button className='btn-action-outline-common btn-action-view '
                            onClick={() => onRecordClick(rec.cin)}
                            icon={<EyeOutlined/>}>View</Button>
                </Space>
            ),
        },
    ];

    const handleSendUsernameAsEmail = (username: string) => {
        if (null != username) {
            setLoading(true)

            modal.confirm({
                title: 'Confirm',
                icon: <ExclamationCircleOutlined/>,
                content: `Are you sure you want to send "${username}" as an email to the user?`,
                okText: 'Yes',
                cancelText: 'No',
                okButtonProps: {style: {background: '#FF7400'}},
                className: 'confirm-dialog-box',
                onOk() {

                    adminService.sendUsernameAsEmail(username).then(res => {
                        if (res.data) {
                            message.success("Username has been sent as an email to the customer successfully")
                            fetchAllCustomerList(pagination.current, pagination.pageSize, filter)
                            setLoading(false)

                        } else {
                            message.error(`Username email sent failed`)
                            setLoading(false)
                        }
                    }, (reason) => {
                        ErrorHandler.handleError(reason);
                        setLoading(false)
                    });
                },
                onCancel() {
                    setLoading(false)
                }
            });
        }
    }

    const handleSwitchChange = (newState: boolean, rec: any) => {
        const originalState = switchStates[rec.username] !== undefined
            ? switchStates[rec.username]
            : rec.status === 'ACTIVE';

        modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined/>,
            content: `Do you want to ${newState ? 'enable' : 'disable'} ${rec.username} user?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            className: 'confirm-dialog-box',
            onOk() {
                let userMstDto = {
                    enabled: newState,
                    userName: rec.username
                } as UserMstDto

                adminService.changeUserStatus(userMstDto).then(res => {
                    if (res.data) {
                        setSwitchStates(prev => ({
                            ...prev,
                            [rec.username]: newState
                        }));
                        message.success(`User ${newState ? 'enabled' : 'disabled'} successfully`).then();
                    } else {
                        message.error(`Failed to ${newState ? 'enable' : 'disable'} user`).then();
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                });
            },
            onCancel() {
                setSwitchStates(prev => ({
                    ...prev,
                    [rec.username]: originalState
                }));
            }
        });

    }
    const getClassName = (text: string) => {
        if (null != text) {
            return text.toUpperCase() == "DRIVING LICENSE" ? 'drl-tbl-tag' : 'tbl-tag'
        }
        return 'tbl-tag';
    }

    const onRecordClick = (cin: string) => {
        localStorage.setItem("adminClickedCin", cin as string)
        history.push('/workflow/admin/customer-details-view')
    }

    const getColor = (identificationSourceType: string) => {
        switch (identificationSourceType) {
            case IDENTIFICATION_SOURCE.NIC: {
                return 'green';
            }
            case IDENTIFICATION_SOURCE.PP: {
                return 'geekblue';
            }
            case IDENTIFICATION_SOURCE.DL: {
                return 'volcano';
            }
            default: {
                return '#8c8c8c';
            }
        }
    }

    const getIdentificationSourceTypes = () => {
        const inputDropdownParameterDto: InputDropdownParameterDto = {
            dropdownDataSourceId: COMMON_DROPDOWN.IDENTIFICATION_SOURCE,
            findTextValue: "",
            parameterList: [PARAMETER_LIST.ACTIVE]
        }
        customerService.getCommonDropdown(inputDropdownParameterDto).then(res => {
            if (res.data !== null) {
                let activeItemList = res.data.results.activeItemList;
                setIdentificationSourceTypeList(activeItemList)
            } else {
                message.error(MSG_FAILED_TO_FETCH_IDENTIFICATION_SOURCE_TYPES_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        })
    }

    useEffect(() => {
        getIdentificationSourceTypes()
        fetchAllCustomerList(pagination.current, pagination.pageSize, filter)
    }, [])

    const fetchAllCustomerList = (page: number, pageSize: number, filterDto: CustomerFilterDto) => {
        setLoading(true)

        filterDto.page = page - 1;
        filterDto.size = pageSize;

        adminService.fetchAllCustomers(filterDto).then((res => {
            if (res.data !== null && res.data.results) {
                let results = res.data.results;
                setTableData(results.customCustomerMstDtoList)
                setPagination({
                    current: results.page + 1, // Adjusting to be 1-based index
                    pageSize: results.size,
                    total: results.allCount,
                });
                setLoading(false)
            } else {
                setLoading(false)
                message.error(MSG_FAILED_TO_FETCH_CUSTOMER_DETAILS_ERROR).then();
            }
        })).catch((reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        });
    }

    const handlePaginationChange = (page: number, pageSize: number) => {
        fetchAllCustomerList(page, pageSize, filter);
    };

    const onFilter = () => {
        let fieldsValues: CustomerFilterDto = form.getFieldsValue();

        let filterDto: CustomerFilterDto = {
            cin: checkUndefined(fieldsValues.cin),
            contactNo: checkUndefined(fieldsValues.contactNo),
            customerName: checkUndefined(fieldsValues.customerName),
            email: checkUndefined(fieldsValues.email),
            rmId: null,
            identificationSource: checkUndefined(fieldsValues.identificationSource),
            identificationValue: checkUndefined(fieldsValues.identificationValue),
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        fetchAllCustomerList(1, pagination.pageSize, filterDto);
    }

    const checkUndefined = (value: any) => {
        return value == undefined || value == "" ? null : value
    }

    const onReset = () => {
        form.resetFields();
        let filterDto: CustomerFilterDto = {
            cin: null,
            contactNo: null,
            customerName: null,
            email: null,
            rmId: null,
            identificationSource: null,
            identificationValue: null,
            page: 1,
            size: pagination.pageSize,
            sort: filter.sort
        }
        setFilter(filterDto);
        setPagination({
            ...pagination,
            current: 1,
        });
        fetchAllCustomerList(1, pagination.pageSize, filterDto);
    }

    return (
        <div>
            <Row gutter={[16, 16]}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24} className='page-header-main-title-col'>
                    <h2 className='page-header-main-title'>
                        <div className='header_icon header-icon-center'>
                            <TeamOutlined/>
                        </div>
                        Customer Details List
                    </h2>
                </Col>
            </Row>

            <Row gutter={[16, 16]} className='' style={{marginTop: 8}}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                    <Collapse className={'margin_bottom_20'}>
                        <Panel header="Filter Customers" key="1">
                            <Form
                                layout={"vertical"}
                                form={form}
                            >
                                <Row gutter={[16, 0]}>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="cin" label="CIN">
                                            <Input placeholder={'Enter CIN'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="customerName" label="Customer Name">
                                            <Input placeholder={'Enter Customer Name'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="identificationSource" label="Identification Source">
                                            <Select
                                                placeholder={'Select Identification Source'}
                                                getPopupContainer={(trigger: {
                                                    parentNode: any;
                                                }) => trigger.parentNode}
                                                style={{width: '100%'}}
                                                options={identificationSourceTypeList}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="identificationValue" label="Identification Number">
                                            <Input placeholder={'Enter Identification Number'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="contactNo" label="Contact Number">
                                            <Input placeholder={'Enter Contact Number'}/>
                                        </Form.Item>
                                    </Col>
                                    {/*<Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>*/}
                                    {/*    <Form.Item name="rmId" label="RM Code">*/}
                                    {/*        <Input placeholder={'Enter RM Code'}/>*/}
                                    {/*    </Form.Item>*/}
                                    {/*</Col>*/}
                                    <Col xxl={6} xl={8} lg={8} md={12} sm={24} xs={24}>
                                        <Form.Item name="email" label="Email">
                                            <Input placeholder={'Enter Email'}/>
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row gutter={[16, 0]}>
                                    <Col span={24}>
                                        <Space style={{float: 'right'}}>
                                            <Button style={{
                                                width: 120,
                                                marginRight: 8
                                            }} onClick={onReset}>Reset</Button>
                                            <Button type="success"
                                                    style={{
                                                        width: 120,
                                                        background: "#FF7400",
                                                        color: "white",
                                                    }} onClick={onFilter}>Filter</Button>
                                        </Space>
                                    </Col>
                                </Row>
                            </Form>
                        </Panel>
                    </Collapse>
                </Col>

                <Col span={24}>
                    <Table columns={columns} dataSource={tableData} pagination={false} loading={loading}
                           scroll={{x: 'max-content'}}/>
                    <br/>
                    <Space style={{float: 'right'}}>
                        <Pagination
                            total={pagination.total ?? 0}
                            showTotal={(total: number) => `Total ${total} items`}
                            defaultPageSize={10}
                            defaultCurrent={pagination.current}
                            current={pagination.current}
                            onChange={handlePaginationChange}
                        />
                    </Space>
                </Col>
            </Row>
        </div>
    )
}
export default CustomerDetailsTablePage
